module.exports = __webpack_public_path__ + "static/media/mode-banner.b6ad6985.svg";